import GeneratorView from "../../components/GeneratorView";
import GeneratorOptions from "./GeneratorOptions";

const sieves = (max) => {
  let primes = [...new Array(max)].fill(true);
  primes[0] = false;
  primes[1] = false;

  for (let i = 2; i <= Math.sqrt(max); i++) {
    if (primes[i]) {
      for (let j = i + i; j < max; j += i) {
        primes[j] = false;
      }
    }
  }

  return primes
    .map((p, i) => ({ i, p }))
    .filter(({ p }) => p)
    .map(({ i }) => i);
};

const generate = ({ max }) => sieves(max || 0);

const Index = ({ strings }) => (
  <GeneratorView
    strings={strings}
    options={{ max: 1000000 }}
    optionsView={GeneratorOptions}
    onGenerate={generate}
  />
);

export default Index;
